import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/colors.css';
import './styles/fonts.css';
import './styles/spacings.css';
import './styles/index.css';
import './styles/figma-style.css';
import './styles/bootstrap-fix.css';
import 'typeface-roboto'


import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
